// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectYearMonthDay_wrapper__38n_Z","label":"SelectYearMonthDay_label__IzJPm","select":"SelectYearMonthDay_select__2_LnR","month":"SelectYearMonthDay_month__34nm2"};